import React from 'react';

export default () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 12V3H1.5V12H13.5ZM13.5 0C13.8978 0 14.2794 0.158035 14.5607 0.43934C14.842 0.720644 15 1.10218 15 1.5V12C15 12.3978 14.842 12.7794 14.5607 13.0607C14.2794 13.342 13.8978 13.5 13.5 13.5H1.5C1.10218 13.5 0.720644 13.342 0.43934 13.0607C0.158035 12.7794 0 12.3978 0 12V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0H13.5ZM8.25 10.5V9H12V10.5H8.25ZM5.685 7.5L2.6775 4.5H4.8L7.275 6.975C7.5675 7.2675 7.5675 7.7475 7.275 8.04L4.815 10.5H2.6925L5.685 7.5Z" fill="currentColor" />
  </svg>
);
